module.exports = __webpack_public_path__ + "img/greenprint.77782a43.png";